export const formattingOptionsTooltip = "i4b";
export default {formattingOptionsTooltip};